import React from 'react';

export const GetCrewMembersRepeatingScheduleIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.75 5.25C0.75 4.42157 1.42157 3.75 2.25 3.75H21.75C22.5784 3.75 23.25 4.42157 23.25 5.25V21.75C23.25 22.5784 22.5784 23.25 21.75 23.25H2.25C1.42157 23.25 0.75 22.5784 0.75 21.75V5.25Z"
        stroke="#55565F"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M0.75 9.75H23.25"
        stroke="#55565F"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 6V0.75"
        stroke="#55565F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.25 6V0.75"
        stroke="#55565F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.344 15.75H9V12.75"
        stroke="#55565F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.11804 15.75C9.52733 14.0539 11.0071 12.8316 12.75 12.75C14.4995 12.7499 16.0165 13.9595 16.4061 15.6651C16.7956 17.3706 15.954 19.1189 14.378 19.8783C12.802 20.6377 10.9102 20.2064 9.81904 18.839"
        stroke="#55565F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
